import { supabase } from './index';
import type { ShaderConfig } from '@shadeables/shadermodel';

export interface Project {
  id: string;
  name: string;
  user_id: string;
  config: ShaderConfig;
  created_at: string;
}

export const getProjectById = async (id: string): Promise<Project> => {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) {
    throw new Error('User not found.');
  }

  const { data, error } = await supabase
    .from('projects')
    .select('*')
    .eq('id', id)
    .eq('user_id', user.id)
    .single();

  if (error) {
    throw error;
  }

  return data as Project;
};

export const getProjects = async (): Promise<Project[]> => {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) {
    throw new Error('User not found.');
  }

  const { data, error } = await supabase
    .from('projects')
    .select('*')
    .eq('user_id', user.id);

  if (error) {
    throw error;
  }

  return data as Project[];
};

export interface ProjectCreate {
  name: string;
  config: ShaderConfig;
}

export const createProject = async (
  project: ProjectCreate
): Promise<Project[]> => {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) {
    throw new Error('User not found.');
  }

  const { data, error } = await supabase
    .from('projects')
    .insert([{ ...project, user_id: user.id }])
    .select();

  if (error) {
    throw error;
  }

  return data as Project[];
};

export const updateProject = async (
  id: string,
  config: ShaderConfig
): Promise<Project[]> => {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) {
    throw new Error('User not found.');
  }

  const { data, error } = await supabase
    .from('projects')
    .update({ config })
    .eq('id', id)
    .eq('user_id', user.id)
    .select();

  if (error) {
    throw error;
  }

  return data as Project[];
};
